app.service('orderPath', function (broker, console) {
	function init() {
		$('body').on('click', '.js-next-step', function(){
			console.log('Kliknięcie dalej z nagłówka');
			broker.trigger('ORDER-NEXT-STEP');
		});
	}
	return {
		init
	};
});
